export const accessCodes = {
  human_resources: "Human Resources",
  employee_directory: "Employee Directory",
  departments: "Departments",
  designations: "Designations",
  allowances_deductions: "Allowances & Deductions",
  employee_work_type: "Employee Work Type",
  master: "Master",
  master_academics: "Acadamics",
  master_visatype: "VisaType",
  master_vehicleCategory: "VehicleCategory",
  master_relationship: "Relationship",
  master_race: "Race",
  master_paymode: "PayMode",
  master_passType:"PassType",
  master_nationality: "Nationality",
  master_momTrade: "MOMTrade",
  master_location: "Location",
  master_insuranceType: "InsuranceType",
  master_identification: "Identification",
  master_group: "Group",
  master_foreignerLevy: "ForeignerLevy",
  master_employmentType:"EmploymentType",
  master_employeeStatus: "EmployeeStatus",
  master_dormitory: "Dormitory",
  master_cpftypes: "CPFTypes",
  master_cpfpercentagefli:"CPFPercentageFLI",
  master_cpfpercentage: "CPFPercentage",
  master_cpfcontributionrate:"CPFContributionRate",
  master_cpfcontribution: "CPFContribution",
  master_country: "Country",
  master_contractType:"ContarctType",
  master_bank: "Bank",
  loan_advance: "Loans & Advances",
  advance_disbursement :"Advance Disbursement",
  project_management: "Project Management",
  project_portfolio: "Project Portfolio",
  project_task: "Task Assignments",
  claim_processing: "Claims Processing",
  claim_categories: "Claim Categories",
  claim_manage: "Manage Claims",
  leave_adjustment: "Compensation Adjustments",
  leave_employee_records: "Employee Leave Records",
  leave_holiday_calender: "Holiday Calendar",
  leave_categories: "Leave Categories",
  leave_management: "Leave Management",
  shift_management: "Shift Management",
  shift_employee_mapping: "Employee Shift Mapping",
  shift_policy: "Shift Policies",
  shift_scheduling: "Shift Scheduling",
  time_attendance: "Time & Attendance",
  time_tracking: "Time Tracking",
  time_management: "Timesheet Management",
  settings: "Settings",
  company_setting: "CompanySetting",
  email_setting: "Email Alert Configuration",
  users: "Users",
  user_master: "UsersMaster",
  user_group: "Users Groups",
  payroll_management: "Payroll Management",
  payroll_allowance: "Allowance Management",
  payroll_deduction: "Deduction Management",
  payroll_generation: 'Payroll Generation',
  payroll_processing_stages: "Payroll Processing Stages",
  payroll_records: "Payroll Records",
  others: "Others",
  others_vehicle: "Vehicle",
};
